import React from "react";
import Select, { components } from "react-select";

const SearchSelect = ({
  name,
  value,
  onChange,
  labelClass,
  inputClass,
  errorClass,
  error,
  label,
  isRequired,
  options,
  isMulti,
  defaultValue,
  isDisabled,
  placeholder,
  isClearable,
  // INC-1025: opt-in for multi-selects that want already-picked options to stay
  // visible, checked and greyed out instead of disappearing from the list.
  hideSelectedOptions,
  isOptionDisabled,
}) => {
  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#E7E7E7" : provided.backgroundColor,
      color: state.isDisabled ? "#626262" : provided.color,
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#E7E7E7" : provided.backgroundColor,
      color: state.isDisabled ? "#626262" : provided.color,
    }),
    // INC-1025: an already-picked option that is kept visible via
    // isOptionDisabled should read as disabled, not as the blue "selected"
    // highlight.
    // A selected-but-still-pickable option (checkbox multi-selects) also
    // skips the blue row highlight — the checked checkbox alone conveys
    // selection.
    option: (provided, state) =>
      state.isSelected && state.isDisabled
        ? {
            ...provided,
            backgroundColor: "transparent",
            color: "#626262",
            cursor: "not-allowed",
          }
        : state.isSelected
          ? {
              ...provided,
              backgroundColor: "transparent",
              // react-select pairs its selected background with white text;
              // without that background the label would be invisible, so set
              // the colour explicitly rather than relying on inheritance.
              color: "#0c0c0d",
            }
          : provided,
    menuPortal: (provided) => ({ ...provided, zIndex: 100010 }),
  };

  const Option = (props) => (
    <components.Option {...props}>
      <div className="d-flex align-items-center">
        {props.isMulti && props.data?.value !== "" && (
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            className="me-2"
          />
        )}
        <span>{props.label}</span>
      </div>
    </components.Option>
  );

  const MultiValue = (props) => {
    if (
      props.data?.label === "Select All" ||
      props.data?.label === "All Products"
    ) {
      return null;
    }
    return <components.MultiValue {...props} />;
  };

  const ClearIndicator = (props) => (
    <components.ClearIndicator {...props}>
      <span className="f-sem-bol" style={{ fontSize: "24px", lineHeight: 1 }}>
        ×
      </span>
    </components.ClearIndicator>
  );
  return (
    <>
      {label && (
        <label htmlFor={name} className={`c-label ${labelClass}`}>
          {label} {isRequired && <span className="asterisk f-12">&#42;</span>}
        </label>
      )}
      <div className={`position-relative${isDisabled && " cursor-na"}`}>
        <Select
          className={`${inputClass} ${error ? "error" : ""}`}
          isMulti={isMulti}
          classNamePrefix="select"
          isSearchable={true}
          options={options}
          name={name}
          defaultValue={defaultValue}
          isDisabled={isDisabled}
          isClearable={isClearable}
          hideSelectedOptions={hideSelectedOptions}
          isOptionDisabled={isOptionDisabled}
          value={
            isMulti
              ? value
              : options && options.find((itm) => itm.value === value)
          }
          onChange={onChange}
          maxMenuHeight={200}
          isRequired={isRequired}
          placeholder={placeholder}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={
            isMulti
              ? { Option, MultiValue, ClearIndicator }
              : { ClearIndicator }
          }
          // menuPlacement="auto"
        />
      </div>
      {error && <div className={`invalid ${errorClass}`}>{error}</div>}
    </>
  );
};

export default SearchSelect;
